'use strict';

module.exports = {
  LocalAudioTrack: require('./localaudiotrack'),
  LocalVideoTrack: require('./localvideotrack'),
  LocalDataTrack: require('./localdatatrack')
};


//////////////////
// WEBPACK FOOTER
// ./~/twilio-video/es5/media/track/es5/index.js
// module id = 58
// module chunks = 0